import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Store } from '@ngrx/store'

import { Observable } from 'rxjs'

import { AI_API_PATH } from '@flowx/designer/modules/ai-builder/services/harness-config.service'
import { APP_ID_HEADER } from '@flowx/designer/modules/workspaces/shared/commons.types'
import { REQUEST_SCOPE } from '@flowx/designer/shared/api/request-scope.token'
import { selectAppId } from '@flowx/designer/shared/store/selectors/router.selectors'

@Injectable()
export class AiAppIdInterceptor implements HttpInterceptor {
  #store = inject(Store)
  #appId = this.#store.selectSignal(selectAppId)

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes(`${AI_API_PATH}/`)) {
      return next.handle(request)
    }

    // A harness call that names its own project: the maker's own conversation needs none (the
    // relay reads its absence as the owner route), nor does a turn from outside any project; a plan
    // call needs its write target's.
    const scope = request.context.get(REQUEST_SCOPE)

    if (scope?.type === 'owner' || scope?.type === 'workspace' || scope?.type === 'organization') {
      return next.handle(request.clone({ headers: request.headers.delete(APP_ID_HEADER) }))
    }

    if (scope?.type === 'project') {
      return next.handle(request.clone({ setHeaders: { [APP_ID_HEADER]: scope.appId } }))
    }

    const appId = this.#appId()
    if (!appId) {
      return next.handle(request)
    }

    return next.handle(request.clone({ setHeaders: { [APP_ID_HEADER]: appId } }))
  }
}
